import React from 'react';

import { nonNullable } from '@utilities';
import { isAppRouteGroupType } from '@utilities';
import { isAppRouteSingleType } from '@utilities';
import { AppRoute, AppRouteGroup } from './MenuElement';

type MenuGroupProps = {
  items: AppRouteType[];
};

const needAddSingleRouteToMenu = (route: AppRouteSingleType) => {
  return !!route.url && !!route.menuTitle;
};

export const MenuGroup: React.FC<MenuGroupProps> = ({ items }) => {
  return (
    <>
      {items
        .map(item => {
          if (isAppRouteSingleType(item) && needAddSingleRouteToMenu(item)) {
            return <AppRoute route={item} withWrapper />;
          }
          if (isAppRouteGroupType(item)) return <AppRouteGroup route={item} />;

          return null;
        })
        .filter(nonNullable)
        .map((element, index) => (
          <React.Fragment key={index}>{element}</React.Fragment>
        ))}
    </>
  );
};
